import axios from "axios";
import { useState } from "react";
import { countries } from "country-data";
import { Logo } from "../components/Title/logo";
import MainCard from "../components/Cards/MainCard";
import { TableListItem } from "../components/TableListItem";

function Funding() {
  // checkbox
  const [addressData, setAddressData] = useState({
    donorName: "",
    donorStreet: "",
    donorPostalCode: "",
    donorCity: "",
    donorCountryCode: "DE",
  });

  const [placeHolderAddressData, setPlaceHolderAddressData] = useState({
    donorName: "Contributor's Name",
    donorStreet: "Street Address",
    donorPostalCode: "Postall Code",
    donorCity: "City",
    donorCountry: "Country",
  });

  const [selected, setSelected] = useState(null);
  const [edit, setEdit] = useState(false);

  const [paymentOptions, setPaymentOptions] = useState([
    {
      id: 1,
      name: "Junior Suite",
      amount: 10,
    },
    {
      id: 2,
      name: "Grande Suite",
      amount: 100,
    },
    {
      id: 3,
      name: "PAYJIM Suite",
      amount: 1000,
    },
  ]);

  const handleCheckboxChange = (id) => {
    if (selected === id) {
      setSelected(null);
    } else {
      setSelected(id);
    }
  };

  const handleAddressChange = (event) => {
    const { name, value } = event.target;

    setAddressData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleCountryCodeChange = (event) => {
    setAddressData(() => ({
      donorCountryCode: event.target.value,
    }));
  };

  const handlePay = async (event) => {
    event.preventDefault();
    const fullNameArray = addressData?.donorName?.split(" ");
    const streetAddresArray = addressData?.donorStreet?.split(" ");

    await axios
      .post(`${process.env.REACT_APP_DONATE}/mollie/request-payment`, {
        total: paymentOptions[selected - 1].amount * 100,
        user: {
          first: fullNameArray[0],
          last: fullNameArray[1],
        },
        timestamp: new Date().getTime(),
        item: paymentOptions[selected - 1],
        address: {
          street: streetAddresArray[0],
          number: streetAddresArray[1],
          postalCode: addressData.donorPostalCode,
          city: addressData.donorCity,
          countryCode: countries[addressData.donorCountryCode]?.name,
        },
      })
      .then((res) => {
        window.location.replace(res.data.checkoutUrl);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="w-screen sm:w-[500px] min-w-[340px] mx-auto bg-backgroundLightGrey">
      <div className="flex flex-col items-center h-screen mx-auto pl-4 relative disable ">
        <Logo />
        <MainCard>
          <div className="font-bold text-left">It’s you turn now! </div>
          <div className=" text-[15px] font-light flex-wrap">
            Try our fast check-out process with PAYJIM and help us become the
            category leader in in-room hotel payments by donating. Update your
            billing address for a donation invoice. Thank you for your support.{" "}
            {/* <span>
                <a className="underline" href="https://www.payjim.de/">
                  payjim.de
                </a>
              </span> */}
          </div>
        </MainCard>
        <MainCard>
          <div className="flex flex-row justify-between">
            <div className="text-[24px] font-normal underline">Billed to</div>
            <button
              onClick={() => setEdit(true)}
              className="flex flex-row justify-center"
            >
              <span>
                <img
                  className="text-lightOrange"
                  priority
                  src="/images/Edit.svg"
                  layout="fixed"
                  width={20}
                  height={20}
                  alt="edit"
                />
              </span>
              &nbsp;
              <span className="text-orange">edit</span>
            </button>
          </div>
          {edit ? (
            <form className="text-[12px] font-thin flex flex-col">
              {/* address change */}
              <input
                onChange={handleAddressChange}
                className="border-b bg-inherit w-[50%]"
                type="text"
                name="donorName"
                placeholder={placeHolderAddressData.donorName}
                value={addressData.donorName}
              />
              <input
                className="border-b bg-inherit w-[50%]"
                type="text"
                name="donorStreet"
                placeholder={placeHolderAddressData.donorStreet}
                value={addressData.donorStreet}
                onChange={handleAddressChange}
              />
              <div>
                <input
                  className="border-b bg-inherit w-[22%]"
                  type="text"
                  name="donorPostalCode"
                  placeholder={placeHolderAddressData.donorPostalCode}
                  value={addressData.donorPostalCode}
                  onChange={handleAddressChange}
                />
                <input
                  className="border-b bg-inherit w-[28%]"
                  type="text"
                  name="donorCity"
                  placeholder={placeHolderAddressData.donorCity}
                  value={addressData.donorCity}
                  onChange={handleAddressChange}
                />
              </div>

              <select
                name="country"
                className="border-b bg-inherit w-[50%]"
                value={addressData.donorCountryCode}
                onChange={handleCountryCodeChange}
              >
                {countries.all.map((country, index) => (
                  <option key={index} value={country.alpha2}>
                    {country.name}
                  </option>
                ))}
              </select>

              <div>
                <button
                  onClick={() => setEdit(false)}
                  className="text-orange text-[16px] font-bold"
                >
                  Save changes
                </button>
              </div>
            </form>
          ) : (
            <div className="text-[12px] font-thin">
              <div>
                {addressData.donorName
                  ? addressData.donorName
                  : placeHolderAddressData.donorName}
              </div>
              <div>
                {addressData.donorStreet
                  ? addressData.donorStreet
                  : placeHolderAddressData.donorStreet}
              </div>
              <div>
                {addressData.donorPostalCode
                  ? addressData.donorPostalCode
                  : placeHolderAddressData.donorPostalCode}{" "}
                {addressData.donorCity
                  ? addressData.donorCity
                  : placeHolderAddressData.donorCity}
              </div>
              <div>
                {addressData.donorCountryCode
                  ? countries[addressData.donorCountryCode]?.name
                  : placeHolderAddressData.donorCountry}
              </div>
            </div>
          )}

          <hr className="border-[1.4px] border-t border-gray-400 my-8 " />
          {/* payment selection */}
          {paymentOptions.map((item, index) => (
            <TableListItem
              item={item}
              key={index.toString()}
              onSelect={handleCheckboxChange}
              selected={selected}
            />
          ))}
          <div className="flex flex-col items-end">
            <div align="right" className="text-orange w-[50%]">
              <hr className="border-[1px] border-t border-gray-200 mt-4 " />
              <div className="font-bold flex flex-row justify-between text-[18px] mt-2 mb-4">
                <span>Total (€): </span>
                <span>
                  {!selected
                    ? 0
                    : paymentOptions[selected - 1]?.amount.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </MainCard>

        <div className="flex flex-row items-center justify-center mb-4 w-full">
          <button
            onClick={handlePay}
            className={`${
              !selected ? "bg-darkGrey" : "bg-orange"
            } rounded-lg py-[5px] my-6 shadow-lg text-white text-[14px] w-[60%] h-[38px] flex flex-col items-center justify-center `}
          >
            Continue
          </button>
        </div>
        {/* <BottomIcon /> */}
      </div>
    </div>
  );
}

export default Funding;
